import styled from 'styled-components';

export const StyledParagraph = styled.p<{ noMargin?: boolean }>`
  margin-bottom: ${props => (props.noMargin ? 0 : '2rem')};
  line-height: 1.5rem;
`;
